import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  titulo: string;
  texto: string;
  eleccion: string;
  ok: string;
  ko: string;
}

@Component({
  selector: 'dialogo-popUp',
  templateUrl: './dialogo-popup-layout.html',
  styleUrls: ['./dialogo-popup-layout.scss']
})
export class DialogoPopUpComponent {
  datos;
  constructor(public dialogRef: MatDialogRef<DialogoPopUpComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.datos = data;
  }

  onNoClick(): void {
    this.dialogRef.close('NO');
  }

  onSiClick(): void {
    this.dialogRef.close('SI');
  }
}
